export default function eventTranscript(details) {
  const d = details;
  const code = d?.code;
  switch (code) {
    case 'E21':
      return 'Cooling unit.';
    case 'E22':
      return 'Heating unit.';
    case 'E61':
      return 'Internal airflow.';
    case 'E63':
      return 'Radiator airflow.';
    case 'E71':
      return 'Internal sensor.';
    case 'E81':
      return 'Internal sensor.';
    case 'E73':
      return 'Environment sensor.';
    case 'E83':
      return 'Environment sensor.';
    default:
      return `${typeof code === 'string' ? code : 'Undefined error.'}`;
  }
}
